export default "__VITE_ASSET__DPcZSx$A__"